import { __read, __spread } from "tslib";
import { KEEN_KEY } from '@keen.io/parser';
import { transformData } from './transformations';
import { exportToCSV } from './csv';
var DataExport = (function () {
    function DataExport() {
    }
    DataExport.exportToCSV = function (payload) {
        var data = payload.data, lineDelimiter = payload.lineDelimiter, columnDelimiter = payload.columnDelimiter;
        return exportToCSV(data, columnDelimiter, lineDelimiter);
    };
    DataExport.exportRawData = function (_a) {
        var query = _a.query, keys = _a.keys, data = _a.data;
        var analysisType = query.analysis_type;
        var isDataSelection = ['extraction', 'select_unique'].includes(analysisType);
        var columns = __spread((isDataSelection ? [] : [KEEN_KEY]), keys);
        return __spread([
            columns
        ], data.map(function (item) { return __spread((isDataSelection ? [] : [item[KEEN_KEY]]), keys.map(function (keyName) { return item[keyName]; })); }));
    };
    DataExport.exportVisualizationData = function (payload) {
        return transformData(payload);
    };
    return DataExport;
}());
export default DataExport;
